export const Method_Get_Videos_List = 'video-catalog/';
export const Method_Get_Videos_Category = 'video-category/';